var _circle, _tspan, _tspan2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "300px",
    width: "300px",
    viewBox: "-300 -300 600 600",
    fontFamily: "Bitstream Vera Sans,Liberation Sans, Arial, sans-serif",
    fontSize: 72,
    textAnchor: "middle",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    stroke: "#AAA",
    strokeWidth: 10,
    r: 280,
    fill: "#FFF"
  })), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "#444"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: -8
  }, "NO IMAGE")), _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 80
  }, "AVAILABLE"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImg);
export default __webpack_public_path__ + "static/media/no_img.1edd6fd364814829a6a7f0133e3bcf0b.svg";
export { ForwardRef as ReactComponent };